"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Badge');

function Badge(_ref) {
  var classesProp = _ref.classes,
      children = _ref.children,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "children", "overrides", "className", "type"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Badge.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (0, _defineProperty2.default)({}, classes[type], type), classNameProp);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rootProps, override.root), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    size: "small",
    className: classes.Text
  }, override.Text), children));
}

Badge.overrides = ['root', 'Text'];
Badge.defaultProps = {
  className: '',
  overrides: {},
  type: 'default'
};
process.env.NODE_ENV !== "production" ? Badge.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  type: _propTypes.default.oneOf(['error', 'default', 'info', 'success', 'warn'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Badge);

exports.default = _default;